// The element's type picker, in the two places it can be chosen.

// Options for it, in the shape the `select` widget wants.
//
// The whole content of this module is the FIRST entry, and it is not cosmetic.
//
// `/Page/Element.type` defaults to "" and its enum is ["section", "code"], so a
// select built from the enum alone offers no option for the value the field
// actually holds when the add dialog opens. A controlled <select> whose value
// matches none of its options falls back to selecting the first one — React
// does this explicitly — so the control SHOWS "section" while the form holds
// "".
//
// What that costs is a dialog that opens saying "section" and never shows the
// section picker beside it: choosing "section" out of that dropdown selects
// what is already selected, so the browser fires no `change`, `type` stays "",
// and `config`'s oneOf resolves to no branch. Choosing "code" and coming back
// is two real changes, and the picker appears — which is what the bug looked
// like from the outside, and why it survived a spec and a suite.
//
// Neither of those could see it. `userEvent.selectOptions` and Playwright's
// `selectOption` both dispatch `change` whether or not the selection moved, so
// both take a path a person cannot: they set a value the dropdown was already
// showing. The assertion that catches it is on what the control SHOWS when the
// dialog opens, and both suites now make it.
//
// An empty option is what the section picker beside it has always had ("Select
// a section"); this is the same option on the field in front of it. It cannot
// be an empty entry in the enum instead: `config` resolves its oneOf branch by
// that enum's INDEX (common/schema/page-element/fields.js), so prepending to it
// would point every element at the wrong branch.
export const typeOptions = ({ enum: types }) => [
  { value: "", label: "Select a type" },
  ...(types || []).map((value) => ({ value, label: value })),
];

// The field both callers configure, rather than the options alone: what they
// have to agree on is that the type field HAS an empty option, and a shared
// options function they each have to remember to wire up is exactly the
// agreement that drifts.
//
// No `widget` here. `type` is a string with an `enum`, which form-schema
// already resolves to `select` — unlike `sectionId` beside it, a free string
// whose config has to name the widget.
export const TYPE_FIELD = { property: "type", options: typeOptions };
